import React from "react";

const EndDateChangeCircle = ({ percentage = 0, size = 150, strokeWidth = 12 }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  const getColor = () => {
    if (percentage < 30) return "#e74c3c";
    if (percentage < 70) return "#f39c12";
    return "#2ecc71";
  };

  return (
    <div className="d-flex flex-column align-items-center">
      <svg width={size} height={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="transparent"
          stroke="#e0e0e0"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="transparent"
          stroke={getColor()}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
        <text
          x="50%"
          y="50%"
          dominantBaseline="middle"
          textAnchor="middle"
          fontSize="22"
          fontWeight="bold"
          fill="#34495e"
          style={{ fontFamily: "Cairo" }}
        >
          {percentage.toFixed(1)}%
        </text>
      </svg>
      <p style={{ fontFamily: "Cairo", fontWeight: "500", marginTop: "10px" }}>
        معدل التغير في نهاية المشروع
      </p>
    </div>
  );
};

export default EndDateChangeCircle;
